import { useEffect, useMemo, useState } from 'react';
import {
    Avatar,
    AvatarFallback,
    AvatarImage,
} from '../../../../components/avatar';
import { Badge } from '../../../../components/badge';
import MobileProfileMenu from '../MobileProfileMenu';
import type { HeaderNavLinks, HeaderUserData } from '../Header';

interface MobileUserMenuProps {
    userData: HeaderUserData;
    profileLinks: HeaderNavLinks;
    onLogout: () => void;
    currentUrl: string;
    currentCountryCode?: string;
}

export const MobileUserMenu = (props: MobileUserMenuProps) => {
    const { userData, profileLinks, onLogout, currentUrl, currentCountryCode } =
        props;
    const {
        avatarSrc = '',
        firstName,
        lastName = '',
        notificationsCount,
    } = userData;

    const [showMenu, setShowMenu] = useState(false);
    const initials = useMemo(() => {
        return `${firstName[0]?.toUpperCase() ?? ''}${lastName[0]?.toUpperCase() ?? ''}`;
    }, [firstName, lastName]);

    useEffect(() => {
        // Close the menu on page navigation.
        setShowMenu(false);
    }, [currentUrl]);

    return (
        <div>
            <div className="relative">
                <Avatar
                    size="square40"
                    role="button"
                    aria-label="My Profile"
                    onClick={() => {
                        setShowMenu((state) => !state);
                    }}
                >
                    <AvatarImage src={avatarSrc} />
                    <AvatarFallback>{initials}</AvatarFallback>
                </Avatar>

                {notificationsCount > 0 ? (
                    <div className="absolute -top-1 -right-1 flex">
                        <Badge
                            size="centeredCompact"
                            text={notificationsCount > 9 ? 'small' : 'default'}
                        >
                            {notificationsCount > 9 ? '9+' : notificationsCount}
                        </Badge>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {showMenu && (
                <MobileProfileMenu
                    userData={userData}
                    profileLinks={profileLinks}
                    setShowProfileMenu={setShowMenu}
                    showProfileMenu={showMenu}
                    onLogout={onLogout}
                    currentCountryCode={currentCountryCode}
                />
            )}
        </div>
    );
};
